import { parseNumberToCurrencyFormat } from '../../../helpers/parseCurrencyFormat';

export const getRangeColumnCharts = ({ series, formatToGBP = true }) => ({
  chart: {
    height: 350,
    type: 'rangeBar',
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    offsetY: 7,
  },
  yaxis: {
    labels: {
      offsetX: -10,
      formatter(y) {
        return formatToGBP ? parseNumberToCurrencyFormat(y) : y;
      },
    },
  },
  tooltip: {
    followCursor: true,
    y: {
      formatter(y) {
        if (typeof y !== 'undefined' && formatToGBP) {
          return parseNumberToCurrencyFormat(y);
        }
        return y;
      },
    },
  },
  grid: {
    borderColor: 'green',
    padding: {
      top: -20,
      right: 0,
      bottom: -5,
      left: 0,
    },
  },
  colors: ['#7b70ef', '#f8ac59'],
  series,
});
